import React from 'react'
const { PUBLIC_URL } = process.env

const ContentBanner = ({ title, text, imageSrc, imageFile }) => {
  return (
    <div className="dealmed-content-banner">
      <div className="dealmed-container">
        <div className="dealmed-content-banner__content">
          <h2 className="dealmed-content-banner__title">{title}</h2>
          <p className="dealmed-content-banner__text">{text}</p>
        </div>
        <div className="dealmed-content-banner__image-wrapper">
          <img src={imageSrc.fields.file.url} className="dealmed-content-banner__image" alt="" />
          {/* <img src={imageFile.fields.file.url} className="dealmed-content-banner__image" alt="" /> */}
        </div>
      </div>
    </div>
  )
}

export default ContentBanner
